import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Container } from "react-bootstrap";
import * as EmailValidator from "email-validator";
import Chat from "./Chat";
import { useAuthState } from "react-firebase-hooks/auth";
import { useCollection } from "react-firebase-hooks/firestore";
import "./ChatList.css";
import { auth, db } from "../firebase";

function ChatList() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [inputEmail, setInputEmail] = useState();
  const [user] = useAuthState(auth);
  const userChatRef = db
    .collection("chats")
    .where("users", "array-contains", user.email);

  const [chatsSnapshot] = useCollection(userChatRef);

  const handleInput = () => {
    if (!inputEmail) return null;

    if (
      EmailValidator.validate(inputEmail) &&
      !chatAlreadyExist(inputEmail) &&
      inputEmail !== user.email
    ) {
      db.collection("chats").add({
        users: [user.email, inputEmail],
      });
    }
    handleClose();
  };
  const chatAlreadyExist = (email) =>
    !!chatsSnapshot?.docs.find(
      (chat) => chat.data().users.find((user) => user === email)?.length > 0
    );

  return (
    <div>
      <Container>
        <h1 className="text-center">Chats</h1>
        <div className="emailModal">
          <Button className="addChat_btn" onClick={() => setShow(true)}>
            Add New Chat
          </Button>
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Add to Chat</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ display: "flex" }}>
              <input
                className="emailModal"
                type="email"
                value={inputEmail}
                onChange={(e) => setInputEmail(e.target.value)}
              />
              <Button
                variant="success"
                onClick={handleInput}
                style={{ marginLeft: "1rem" }}
              >
                ADD
              </Button>
            </Modal.Body>
          </Modal>
        </div>
        <Container className="chatscroll">
          {chatsSnapshot?.docs.map((chat) => (
            <Chat key={chat.id} id={chat.id} users={chat.data().users} />
          ))}
        </Container>
      </Container>
    </div>
  );
}

export default ChatList;
